import React from 'react';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="home" className="hero-section">
      {/* Background Image */}
      <div 
        className="hero-background"
        style={{ 
          backgroundImage: `url(https://customer-assets.emergentagent.com/job_6220fb1b-1932-491e-bb5b-13d26d657289/artifacts/snwmj820_im3rd-media-FJZtZldA-uE-unsplash.jpg)` 
        }}
      />
      <div className="hero-overlay" />

      {/* Content */}
      <div className="container hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            Transforming Spaces,<br />Painting Dreams
          </h1>
          <p className="hero-subtitle">
            Where Every Stroke Tells Your Story
          </p>
          <p className="hero-description">
            From Vision to Reality - Crafting Timeless Beauty, One Wall at a Time
          </p>
          <button onClick={scrollToContact} className="btn-primary hero-cta">
            Get Free Consultation
            <ArrowRight size={20} />
          </button>
          
          {/* Trust Indicators */}
          <div className="trust-indicators">
            <div className="trust-item">
              <div className="trust-number">15+</div>
              <div className="trust-label">Years Experience</div>
            </div>
            <div className="trust-item">
              <div className="trust-number">500+</div>
              <div className="trust-label">Projects Completed</div>
            </div>
            <div className="trust-item">
              <div className="trust-number">450+</div>
              <div className="trust-label">Happy Clients</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;